/**
 * @file src/firebase/db.js
 * @description Firestore database instance for real-time data access
 * 
 * Re-exports Firestore instance for capsule storage, user profiles, contacts, settings.
 * All data is encrypted client-side before reaching Firestore (AES-256).
 * 
 * Collections:
 *   /users/{uid} - User document with profile and settings
 *   /users/{uid}/capsules/{capsuleId} - Individual capsule metadata
 *   /users/{uid}/capsules/{capsuleId}/entries/{entryId} - Capsule content
 *   /users/{uid}/capsules/{capsuleId}/contacts/{contactId} - Trusted recipients
 *   /users/{uid}/contacts/{contactId} - Global contacts list
 * 
 * @exports
 *   - db: Firestore instance
 * 
 * @example
 *   import db from '../firebase/db';
 *   import { getDoc, doc } from 'firebase/firestore';
 *   
 *   const capsule = await getDoc(doc(db, 'users', uid, 'capsules', capsuleId));
 */

// src/firebase/db.js
// Re-exports the Firestore instance using the already-initialized Firebase app.
import { getFirestore } from "firebase/firestore";
import { app } from "./firebaseConfig";

const db = getFirestore(app);

export default db;
